import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import Home from '@/pages/Home'
import Calculators from '@/pages/Calculators'
import Glossary from '@/pages/Glossary'
import About from '@/pages/About'
import StraightLine from '@/pages/calculators/StraightLine'
import DoubleDeclining from '@/pages/calculators/DoubleDeclining'
import MACRS from '@/pages/calculators/MACRS'
import RentalProperty from '@/pages/calculators/RentalProperty'
import ComputerHardware from '@/pages/calculators/ComputerHardware'
import FurnitureAppliances from '@/pages/calculators/FurnitureAppliances'
import HeavyEquipment from '@/pages/calculators/HeavyEquipment'
import BusinessVehicles from '@/pages/calculators/BusinessVehicles'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/calculators', element: <Calculators /> },
  { path: '/glossary', element: <Glossary /> },
  { path: '/about', element: <About /> },
  { path: '/calculator/straight-line', element: <StraightLine /> },
  { path: '/calculator/double-declining', element: <DoubleDeclining /> },
  { path: '/calculator/macrs', element: <MACRS /> },
  { path: '/calculator/rental-property', element: <RentalProperty /> },
  { path: '/calculator/computer-hardware', element: <ComputerHardware /> },
  { path: '/calculator/furniture-appliances', element: <FurnitureAppliances /> },
  { path: '/calculator/heavy-equipment', element: <HeavyEquipment /> },
  { path: '/calculator/business-vehicles', element: <BusinessVehicles /> },
]

function App() {
  return useRoutes(routes)
}

export default App
